import type { InputHTMLAttributes, ReactNode } from "react";

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  icon?: ReactNode;
};

export function TextInput({ icon, className = "", ...rest }: TextInputProps) {
  return (
    <div className="flex h-12 items-center gap-2 rounded-input border border-border bg-surface px-3.5">
      {icon ? <span className="text-text-faint-2">{icon}</span> : null}
      <input
        className={`h-full w-full bg-transparent text-[15px] text-text placeholder:text-text-faint-2 focus:outline-none ${className}`}
        {...rest}
      />
    </div>
  );
}
